import type { CSSProperties } from 'react';
import { styled } from '@mui/material';

export const StyledDatePicker = styled('div')<{ hasError: boolean }>(({ hasError, theme }) => ({
  border: '1px solid',
  borderColor: `${hasError ? theme.palette.error.main : theme.palette.secondary.main} !important`,
  borderRadius: '4px',
  paddingY: theme.spacing(1),
}));

export const DatePickerWrapper = styled('div')<{
  inputStyles?: CSSProperties;
  backgroundColor?: string;
  borderColor?: string;
  hasError?: boolean;
  lightError?: boolean;
  hasIcon?: boolean;
}>(({ inputStyles, backgroundColor, borderColor, hasError, lightError, hasIcon, theme }) => ({
  display: 'flex',
  flex: 1,
  height: '100%',
  width: '100%',
  ...(borderColor && {
    border: `1px solid ${borderColor}`,
  }),
  '& .react-datepicker': {
    display: 'flex',
  },
  '& .react-datepicker-popper': {
    zIndex: 100000,
  },
  '& .react-datepicker-wrapper': {
    width: '100%',
    height: '100%',
  },
  '& .react-datepicker__input-container input': {
    width: '100%',
    padding: hasIcon ? '10px 10px 10px 38px' : '10px',
    height: '100%',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: '4px',
    backgroundColor: hasError && !lightError ? theme.palette.error.light : backgroundColor,
    ...inputStyles,

    [theme.breakpoints.down('md')]: {
      padding: hasIcon ? '2px 2px 2px 26px' : '6px',
    },
  },
  '& .react-datepicker__calendar-icon': {
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: -5,
      fontSize: '20px',
    },
  },
}));
